import * as UserActions from './actions';
import { ProjectDto } from '@api/projects/interfaces'
import { UserDto } from '@api/users/interfaces';

export interface UserState extends UserDto {
	authorized: boolean
	loading: boolean
	active_project: ProjectDto
	userHash: string
}

export const initialState: UserState = {
	username: '',
	userHash: '',
	roles: [],
	email: '',
	active_project: null,
	disabled: false,
	authorized: false,
	loading: false,
};

export function reducer(
	state = initialState,
	action: UserActions.Actions
): unknown {
	switch (action.type) {
		case UserActions.LOGIN:
		case UserActions.REGISTER:
		case UserActions.LOAD_CURRENT_ACCOUNT:
			return {
				...state,
				loading: true
			};
		case UserActions.LOGIN_SUCCESSFUL:
			return {
				...state,
				...action.payload,
				authorized: true,
			};
		case UserActions.REGISTER_SUCCESSFUL:
		case UserActions.LOAD_CURRENT_ACCOUNT_SUCCESSFUL:
			return {
				...state,
				...action.payload,
				loading: false,
				authorized: true,
			};
		case UserActions.LOGIN_UNSUCCESSFUL:
		case UserActions.REGISTER_UNSUCCESSFUL:
		case UserActions.LOAD_CURRENT_ACCOUNT_UNSUCCESSFUL:
			return {
				...state,
				loading: false,
				authorized: false
			};
		case UserActions.FLUSH_USER:
			return {
				id: '',
				name: '',
				role: '',
				email: '',
				avatar: '',
				authorized: false,
				loading: false,
			};
		case UserActions.LOCKED_USER:
			return {
				...state,
				authorized: false,
				loading: false
			};
		case UserActions.CHANGE_PROJECT:
			return {
				...state,
				...action.payload,
				loading: false
			};
		case UserActions.EMPTY_ACTION:
			return {
				...state,
				loading: false
			};
		default:
			return state;
	}
}

export const getUser = (state: UserState): UserState => state;
